const page = () => {
  return <div>Reporting</div>
}

export default page
